/**
 * Item 2 — par registro do Ministério da Saúde + validade de UM país da solicitação.
 * Espelha o RequestCountryRecordVm da API.
 */
export class RequestCountryRecord {
    id: string;
    country: string;
    ministryRecord: string;
    recordValidity: any;

    constructor(country: string = null) {
        this.country = country;
        this.ministryRecord = null;
        this.recordValidity = null;
    }
}
